// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"L3-z","upvoteIcon":"M3-z","downvoteIcon":"N3-z","feedbackIcon":"O3-z"};